import React from "react";

// Clone of Baccarat Roadmap

import {
	addBigRoadDisplay,
	addDisplayTile,
	addRoadmapType,
	addTieDisplay,
	checkLastIdx,
	prepareV3Render,
	renderV3,
	resetAnalysisPointer,
	resetDisplayPointer,
	resetTieCount,
} from "@/modules/games/BaccaratRoadmaps";

import {
	getDragonVal,
	getTigerVal
} from "@/modules/games/DragonTiger";

import { IV2RoadmapClass } from "@/types/V2RoadmapTypes";

export default class M23 extends IV2RoadmapClass {
	dragonPrediction: JSX.Element[];
	tigerPrediction: JSX.Element[];

	render() {
		prepareV3Render(this);

		//Obligatory counters
		this.currentRow = 0;
		this.currentCol = -1;
		this.currentType = "";
		
		// Formats history to desired roadmap
		switch (this.props.type) {
			case "bead-road":
				this.currentRow = -1;
				this.currentCol = 0;
			
				//Note: always use actual history array on release
				const history = this.props.history;

				//Skips render when history props is empty
				if (!history) return null;

				//Formula: history length divided by displayed rows
				if (Math.ceil(history.length / 6) >= this.totalColumns)
					this.firstDisplayedCol = Math.ceil(history.length / 6) - this.totalColumns;
			
				// console.log("m23 hist", history);
			
				history.forEach((item, idx) => {
					let ele = null;
					
					const dragonVal = getDragonVal(item);
					const tigerVal = getTigerVal(item);

					if (this.currentRow >= 5) {
						this.currentRow = 0;
						this.currentCol += 1;
					} else
						this.currentRow += 1;
					
					if (item.win === "tiger") {
						ele = (<div className={"sl-roadmap-circle sl-roadmap-blue " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
							<div className={"sl-baccarat-bead-value " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
								{tigerVal}
							</div>
						</div>);
					} else if (item.win === "dragon") {
						ele = (<div className={"sl-roadmap-circle sl-roadmap-red " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
							<div className={"sl-baccarat-bead-value " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
								{dragonVal}
							</div>
						</div>);
					} else { //tie
						ele = (<div className={"sl-roadmap-circle sl-roadmap-green " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
							<div className={"sl-baccarat-bead-value " + (checkLastIdx(this.props.history, idx) ? this.alternatingStyle : null)}>
								{dragonVal}
							</div>
						</div>);
					}
					
					this.roadmapDisplay[this.currentRow][this.currentCol] = ele;
				});
			break;
			
			case "big-road":
			case "big-eye-road":
			case "small-road":
			case "cockroach-road":
			case "predictions":
				resetDisplayPointer(this);
				resetAnalysisPointer(this);
				
				// console.log("sBR", this.simpleBigRoad);
				
				//Actual data
				this.simpleBigRoad
				.forEach((item, idx) => {
					if (item === "t")
						addTieDisplay(this, this.roadmapTiesDisplay);
					else {
						addBigRoadDisplay(this, this.roadmapDisplay, 
							item === "D" ?
								<div key={"sBR" + idx}
									 className={"sl-roadmap-circle-hollow sl-roadmap-red " + (checkLastIdx(this.simpleBigRoad, idx) ? this.alternatingStyle : 0)} /> :
							item === "T" ?
								<div key={"sBR" + idx}
									 className={"sl-roadmap-circle-hollow sl-roadmap-blue " + (checkLastIdx(this.simpleBigRoad, idx) ? this.alternatingStyle : 0)} /> :
							null
						, item);
						
						// Use straight columns to set this.roadmapTypes columns, not dragon tail
						
						addRoadmapType(this, this.roadmapTypes, item);
						
						resetTieCount(this);
					}
				});

				resetDisplayPointer(this);
			break;

			default: break;
		}

		//Resets counter for 2nd filter
		// this.currentRow = 0;
		// this.currentCol = 0;
		
		let startingCol: number,
			startingRow: number;
		
		let redElement: JSX.Element,
			blueElement: JSX.Element,
			redBlinkElement: JSX.Element,
			blueBlinkElement: JSX.Element;
		
		switch (this.props.type) {
			case "big-eye-road":
				redElement = <div className="sl-roadmap-circle-hollow sl-roadmap-red" />;
				blueElement = <div className="sl-roadmap-circle-hollow sl-roadmap-blue" />;

				redBlinkElement = <div className={"sl-roadmap-circle-hollow sl-roadmap-red " + this.alternatingStyle} />;
				blueBlinkElement = <div className={"sl-roadmap-circle-hollow sl-roadmap-blue " + this.alternatingStyle} />;
				startingCol = 1;
				break;
			case "small-road":
				redElement = <div className="sl-roadmap-circle sl-roadmap-red" />;
				blueElement = <div className="sl-roadmap-circle sl-roadmap-blue" />;

				redBlinkElement = <div className={"sl-roadmap-circle sl-roadmap-red " + this.alternatingStyle} />;
				blueBlinkElement = <div className={"sl-roadmap-circle sl-roadmap-blue " + this.alternatingStyle} />;
				startingCol = 2;
				break;
			case "cockroach-road":
				redElement = <div className="sl-roadmap-slash sl-roadmap-red" />;
				blueElement = <div className="sl-roadmap-slash sl-roadmap-blue" />;

				redBlinkElement = <div className={"sl-roadmap-slash sl-roadmap-red " + this.alternatingStyle} />;
				blueBlinkElement = <div className={"sl-roadmap-slash sl-roadmap-blue " + this.alternatingStyle} />;
				startingCol = 3;
				break;
			default: break;
		}
		
		let a = 0;

		let lengthLeft = 0, lengthRight = 0;

		switch (this.props.type) {
			case "big-eye-road":
			case "small-road":
			case "cockroach-road":
				this.currentRow = 1;
				this.currentCol = startingCol; //1 //for big-eye-road
				
				
				for (a = 0; a < 9; a++)
					this.roadmapDisplay[a] = "123456789".split("").map(item => null);
				
				//Evaluate the same column, first column
				if (this.roadmapTypes[1][this.currentCol]) {
					for (a = 1; a < this.roadmapTypes.length; a++) {
						if (!this.roadmapTypes[a][this.currentCol])
							break;
						
						//Evaluate the same column
						//startingCol = 1 for big-eye-road
						if (this.roadmapTypes[a][this.currentCol - startingCol] ===
							this.roadmapTypes[a - 1][this.currentCol - startingCol])
							addDisplayTile(this, this.roadmapDisplay, redElement, "red");
						else addDisplayTile(this, this.roadmapDisplay, blueElement, "blue");
					}
				}
				
				this.currentRow = 0;
				this.currentCol++;
				
				for (; this.currentCol < this.roadmapTypes[0].length;) {
					//Evaluate the next column
					if (this.roadmapTypes[0][this.currentCol]) {
						//Count filled cells
						lengthLeft = 0; lengthRight = 0;
	
						//startingCol = 1 for big-eye-road
						for (a = 0; a < this.roadmapTypes.length; a++) {
							if (this.roadmapTypes[a][this.currentCol - startingCol - 1])
								lengthLeft++;
							if (this.roadmapTypes[a][this.currentCol - 1])
								lengthRight++;
						}
						
						// console.log("left:" + lengthLeft, "right:" + lengthRight);
						//Compare column lengths
						if (lengthLeft === lengthRight)
							addDisplayTile(this, this.roadmapDisplay, redElement, "red");
						else addDisplayTile(this, this.roadmapDisplay, blueElement, "blue");
					}
					
					this.currentRow++;
					
					//Checks empty cell of the next row
					if (this.roadmapTypes[this.currentRow][this.currentCol])
						for (; this.currentRow < this.roadmapTypes.length; this.currentRow++) {
							//Evaluate the same column
							
							//Checks empty cell
							if (this.roadmapTypes[this.currentRow][this.currentCol]) {
								//Checks adjacent cells
								if (this.roadmapTypes[this.currentRow][this.currentCol - startingCol] === //1
									this.roadmapTypes[this.currentRow - 1][this.currentCol - startingCol])
									addDisplayTile(this, this.roadmapDisplay, redElement, "red");
								else addDisplayTile(this, this.roadmapDisplay, blueElement, "blue");
							} else break;
						}
	
					this.currentRow = 0;
					this.currentCol++;
				}
				
				// console.log("cR cC", this.currentDisplayRow, this.currentDisplayCol);
				if (this.props.historyBlink &&
					this.simpleBigRoad[this.simpleBigRoad.length - 1] !== "t")
					if (this.currentType === "red")
						this.roadmapDisplay[this.currentDisplayRow][this.currentDisplayCol] = redBlinkElement;
					else this.roadmapDisplay[this.currentDisplayRow][this.currentDisplayCol] = blueBlinkElement;
			break;
			
			
			case "predictions":
				this.dragonPrediction = [];
				this.tigerPrediction = [];
				const redElements = [
					<div key="roadmap_circle_hollow_dragon" className="sl-roadmap-circle-hollow sl-roadmap-blue" />,
					<div key="roadmap_circle_dragon" className="sl-roadmap-circle sl-roadmap-blue" />,
					<div key="roadmap_slash_dragon" className="sl-roadmap-slash sl-roadmap-blue" />
				];
				const blueElements = [
					<div key="roadmap_circle_hollow_tiger" className="sl-roadmap-circle-hollow sl-roadmap-red" />,
					<div key="roadmap_circle_tiger" className="sl-roadmap-circle sl-roadmap-red" />,
					<div key="roadmap_slash_tiger" className="sl-roadmap-slash sl-roadmap-red" />
				];
					
				startingCol = 0;
				startingRow = 0;
				
				// console.log("rT", this.roadmapTypes);

				const lastBigRoadSequence = this.bigRoadSequence[this.bigRoadSequence.length - 1];
				if (lastBigRoadSequence === undefined)
					break;
				
				startingRow = this.bigRoadSequence[this.bigRoadSequence.length - 1][0];
				startingCol = this.bigRoadSequence[this.bigRoadSequence.length - 1][1];
				
				this.currentType = this.roadmapTypes[startingRow][startingCol];
				
				const currentPlayer = 
					this.currentType === "T" ? "tiger" : 
					this.currentType === "D" ? "dragon" : "tie";
					
					
				// console.log("bRS", this.bigRoadSequence);
				
				//Use this.currentRow only for predictions on the same column (the same currentPlayer)
				for (a = 0; a < this.roadmapTypes.length; a++)
					if (this.roadmapTypes[a][this.currentCol])
						startingRow = a;
					else break;
				
				this.currentRow = startingRow;
				this.currentCol = startingCol;
				// console.log({this.currentCol: this.currentCol, this.currentRow: this.currentRow, this.currentType: this.currentType, currentPlayer: currentPlayer});
				

				//Banker and player are disabled for now
				
				//Evaluate banker
				if (currentPlayer === "tiger") {
					this.currentRow += 1;
					
					for (a = 0; a < 3; a++) {
						if (this.currentCol - a - 1 < 0)
							this.tigerPrediction[a] = redElements[a];
						else if (this.roadmapTypes[this.currentRow][this.currentCol - a - 1] ===
							this.roadmapTypes[this.currentRow - 1][this.currentCol - a - 1])
							this.tigerPrediction[a] = redElements[a];
						else this.tigerPrediction[a] = blueElements[a];
					}
				} else {
					//evaluate different column
				
					this.currentRow = 0;
					this.currentCol += 1;
					
					for (let col = 0; col < 3; col++) {
						if (this.currentCol - col - 2 < 0) {
							this.tigerPrediction[col] = redElements[col];
							continue;
						}
						
						lengthLeft = 0;
						lengthRight = 0;
						for (a = 0; a < this.roadmapTypes.length; a++) {
							if (this.roadmapTypes[a][this.currentCol - col - 2])
								lengthLeft++;
							if (this.roadmapTypes[a][this.currentCol - 1])
								lengthRight++;
						}
						
						this.tigerPrediction[col] = (lengthLeft === lengthRight) ?
							redElements[col] :
							blueElements[col];
					}
				}
				
				this.currentRow = startingRow;
				this.currentCol = startingCol;
				
				//Evaluate player
				if (currentPlayer === "dragon") {
					this.currentRow += 1;
					
					for (a = 0; a < 3; a++) {
						if (this.currentCol - a - 1 < 0)
							this.dragonPrediction[a] = blueElements[a];
						else if (this.roadmapTypes[this.currentRow][this.currentCol - a - 1] ===
							this.roadmapTypes[this.currentRow - 1][this.currentCol - a - 1])
							this.dragonPrediction[a] = redElements[a];
						else this.dragonPrediction[a] = blueElements[a];
					}
				} else {
					//evaluate different column

					this.currentRow = 0;
					this.currentCol += 1;

					lengthLeft = 0;
					lengthRight = 0;
					
					for (let col = 0; col < 3; col++) {
						if (this.currentCol - col - 2 < 0) {
							this.dragonPrediction[col] = blueElements[col];
							continue;
						}
						
						lengthLeft = 0;
						lengthRight = 0;
						for (a = 0; a < this.roadmapTypes.length; a++) {
							if (this.roadmapTypes[a][this.currentCol - col - 2])
								lengthLeft++;
							if (this.roadmapTypes[a][this.currentCol - 1])
								lengthRight++;
						}
						
						this.dragonPrediction[col] = (lengthLeft === lengthRight) ?
							redElements[col] :
							blueElements[col];
					}
				}
				
				
			break;
			default: break;
		}
		
		return renderV3(this);
	}
}
